import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles
} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'

import React from 'react'
import PropTypes from 'prop-types'

import { ChevronDownIcon } from 'asterX-UI/Icons'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: 14,
    fontWeight: 400,
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    flexBasis: '20%'
  },
  root: {
    padding: '0px',
    borderRadius: 12,
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0
    },
    '&:before': {
      display: 'none'
    }
  }
}))

const AccordionTwoHead = ({
  heading,
  subHeading,
  addTypography,
  hasExpandIcon = true,
  accordionStyles,
  ...other
}) => {
  const classes = useStyles()

  return (
    <Accordion
      TransitionProps={{ unmountOnExit: true }}
      className={classes.root}
      style={accordionStyles}
    >
      <AccordionSummary
        expandIcon={
          hasExpandIcon ? <ChevronDownIcon stroke={GRAY_COLORS[600]} /> : <></>
        }
        {...other}
      >
        {!!heading && (
          <Typography className={classes.heading}>{heading}</Typography>
        )}

        {!!subHeading && (
          <Typography className={classes.secondaryHeading}>
            {subHeading}
          </Typography>
        )}

        {addTypography && addTypography}
      </AccordionSummary>

      <AccordionDetails>{other.children}</AccordionDetails>
    </Accordion>
  )
}

export default AccordionTwoHead

AccordionTwoHead.protoTypes = {
  children: PropTypes.node,
  heading: PropTypes.string,
  subHeading: PropTypes.string
}
